module.exports = __webpack_public_path__ + "img/logo.47b02ddd.png";